<template>
  <el-dialog
    title="选择职能模块"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal="false"
    width="400px"
    @close="close"
  >
    <!-- <div class="form-row">
      <el-input
        v-model="keyword"
        @input="filterShowCategories"
        placeholder="筛选"
        size="mini"
      ></el-input>
      <el-button type="primary" plain size="mini" @click="clearKeyword"
        >清空</el-button
      >
    </div> -->
    <div>
      <el-table
        ref="multipleTable"
        :data="showCategories"
        tooltip-effect="dark"
        style="width: 100%;"
        height="300px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="职能模块" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px;">{{ scope.row }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="close">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirmDialog">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      keyword: '',
      categories: [],
      chooseCatogiries: [],
      couldChooseCategories: [],
      showCategories: [],
    }
  },
  // watch: {
  //   chooseCatogiries(newValue, oldValue) {
  //     this.$nextTick((_) => {
  //       newValue.forEach((row) => {
  //         this.$refs.multipleTable.toggleRowSelection(row, true);
  //       });
  //       console.log(newValue);
  //     });
  //   },
  // },
  async mounted() {
    if (!app.categories) await app.getCats()
    this.categories = app.categories
  },
  methods: {
    // filterShowCategories() {
    //   const str = this.keyword || "";
    //   const reg = new RegExp(str, "ig");
    //   this.showCategories = this.couldChooseCategories.filter((v) => {
    //     return reg.test(v);
    //   });

    //   // couldChooseCategories
    // },
    // clearKeyword() {
    //   this.keyword = "";
    //   this.showCategories = this.couldChooseCategories;
    // },
    handleSelectionChange(val) {
      this.chooseCatogiries = val
    },
    open(couldChooseCategories, defaultCategories) {
      this.keyword = ''
      this.chooseCatogiries = defaultCategories || []
      this.couldChooseCategories = couldChooseCategories || this.categories.map(v => v.名称)
      this.showCategories = this.couldChooseCategories
      this.$nextTick(_ => {
        this.chooseCatogiries.forEach(row => {
          this.$refs.multipleTable && this.$refs.multipleTable.toggleRowSelection(row, true)
        })
      })
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
      this.showCategories = []
      this.chooseCatogiries = []
    },
    async confirmDialog() {
      this.$emit('confirm', this.chooseCatogiries)
      this.dialogVisible = false
    },
  },
}
</script>
<style scoped>
.form-row {
  display: flex;
  margin-bottom: 5px;
}
.form-row .title {
  word-break: keep-all;
}
.form-row .value {
  flex-grow: 1;
}
</style>
